var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bold",
    fill: "#fff",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.997 3.985h2.191v-3.816c-.378-.052-1.678-.169-3.192-.169-3.159 0-5.323 1.987-5.323 5.639v3.361h-3.486v4.266h3.486v10.734h4.274v-10.733h3.345l.531-4.266h-3.877v-2.939c.001-1.233.333-2.077 2.051-2.077z"
  })));
};
export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQm9sZCIgZmlsbD0iI2ZmZiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjQgMjQiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSI1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTE1Ljk5NyAzLjk4NWgyLjE5MXYtMy44MTZjLS4zNzgtLjA1Mi0xLjY3OC0uMTY5LTMuMTkyLS4xNjktMy4xNTkgMC01LjMyMyAxLjk4Ny01LjMyMyA1LjYzOXYzLjM2MWgtMy40ODZ2NC4yNjZoMy40ODZ2MTAuNzM0aDQuMjc0di0xMC43MzNoMy4zNDVsLjUzMS00LjI2NmgtMy44Nzd2LTIuOTM5Yy4wMDEtMS4yMzMuMzMzLTIuMDc3IDIuMDUxLTIuMDc3eiIvPjwvc3ZnPg==";